var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJudiciary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "judiciary") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Judiciary"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.18,
    y: 56.03,
    width: 9.84,
    height: 44.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.09,
    y: 56.03,
    width: 9.84,
    height: 44.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 71.99,
    y: 56.03,
    width: 9.84,
    height: 44.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 94.89,
    y: 56.03,
    width: 9.84,
    height: 44.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 60.08,
    y: 60.95,
    width: 9.84,
    height: 89.2,
    transform: "translate(170.55 40.55) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "109.22 46.19 65 19.53 20.78 46.19 20.4 46.19 20.4 56.03 109.6 56.03 109.6 46.19 109.22 46.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.4,
    y1: 46.19,
    x2: 109.6,
    y2: 46.19
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJudiciary);
export default __webpack_public_path__ + "static/media/judiciary.0a50422cc7d76bbda5bdbe9083bc6678.svg";
export { ForwardRef as ReactComponent };